import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { SOURCE_STATUS_NAME, LINK_ADDED_TYPE_NAME } from '@constants';
import { LinkSourceType, LinkAddedType } from '@services';

export enum TabType {
  LinksSource = 'Links Source',
  LinksAddedType = 'Links Type',
}

interface LinksTableTabsProps {
  activeTab: LinkSourceType;
  onChangeTab: (_e: React.SyntheticEvent, newTab: LinkSourceType) => void;
  addedType: LinkAddedType;
  onChangeAddedType: (_e: React.SyntheticEvent, newTab: LinkAddedType) => void;
}

const tabTitleStyles = {
  fontSize: '16px',
  fontWeight: '600',
  color: '#000',
  marginBottom: '8px',
};

export const LinksTableTabs: React.FC<LinksTableTabsProps> = ({
  activeTab,
  onChangeTab,
  addedType,
  onChangeAddedType,
}) => {
  const [selectedSource, setSelectedSource] = useState<LinkSourceType>(activeTab);
  const [selectedAddedType, setSelectedAddedType] = useState<LinkAddedType>(addedType);

  const handleSourceChange = (_e: React.SyntheticEvent, newTab: LinkSourceType) => {
    setSelectedSource(newTab);
    onChangeTab(_e, newTab);
  };

  const handleAddedTypeChange = (_e: React.SyntheticEvent, newTab: LinkAddedType) => {
    setSelectedAddedType(newTab);
    onChangeAddedType(_e, newTab);
  };

  return (
    <>
      <Typography sx={tabTitleStyles}>{TabType.LinksSource}</Typography>
      <ToggleButtonGroup
        value={selectedAddedType}
        onChange={handleAddedTypeChange}
        color="primary"
        sx={{ marginBottom: '16px', width: 'calc(100% - 204px)' }}
        exclusive
        fullWidth
      >
        <ToggleButton value={LinkAddedType.All}>
          {LINK_ADDED_TYPE_NAME[LinkAddedType.All]}
        </ToggleButton>
        <ToggleButton value={LinkAddedType.SubmittedManually}>
          {LINK_ADDED_TYPE_NAME[LinkAddedType.SubmittedManually]}
        </ToggleButton>
        <ToggleButton value={LinkAddedType.FromScrape}>
          {LINK_ADDED_TYPE_NAME[LinkAddedType.FromScrape]}
        </ToggleButton>
        <ToggleButton value={LinkAddedType.FromCustomer}>
          {LINK_ADDED_TYPE_NAME[LinkAddedType.FromCustomer]}
        </ToggleButton>
      </ToggleButtonGroup>

      <Typography sx={tabTitleStyles}>{TabType.LinksAddedType}</Typography>
      <ToggleButtonGroup
        value={selectedSource}
        onChange={handleSourceChange}
        color="primary"
        sx={{ marginBottom: '16px', width: 'calc(100% - 204px)' }}
        exclusive
        fullWidth
      >
        <ToggleButton value={LinkSourceType.All}>
          {SOURCE_STATUS_NAME[LinkSourceType.All]}
        </ToggleButton>
        <ToggleButton value={LinkSourceType.GoogleImages}>
          {SOURCE_STATUS_NAME[LinkSourceType.GoogleImages]}
        </ToggleButton>
        <ToggleButton value={LinkSourceType.GoogleWeb}>
          {SOURCE_STATUS_NAME[LinkSourceType.GoogleWeb]}
        </ToggleButton>
        <ToggleButton value={LinkSourceType.AtSource}>
          {SOURCE_STATUS_NAME[LinkSourceType.AtSource]}
        </ToggleButton>
      </ToggleButtonGroup>
    </>
  );
};
